const pluck = (array, key) => {
  let newArray = []

  array.map((o) => newArray.push(...o[key]))
  return newArray
}

export default pluck
